import {Box} from "@mui/material";
import React, {Fragment, useState} from "react";
import RemoveCompanyConfirmationModal from "./RemoveCompanyConfirmationModal";
import {Tooltip} from "@mui/material";
import useGetRemoveProcesses from "../../hooks/useGetRemoveProcesses";
import CircularProgress from "@mui/material/CircularProgress";
import commonStyles from "../../organizationMainStyles";
import RemoveProcess from "./RemoveProcess";
import ActionButton from "../../../../common/ActionButton";
import {accessibilityMode, fragmentId} from "../organizationSettingsConstants";
import {getLabel} from "../organizationSettingsUtils";
import InformationTooltip from "../InformationTooltip";

function RemoveProcesses({removeProcesses}) {
    return (
        removeProcesses ?
            <Box sx={styles.sectionWrapper}>
                {removeProcesses.map((removeProcess) => (
                    <RemoveProcess key={removeProcess.id} removeProcess={removeProcess}/>
                ))}
            </Box> : <Fragment/>
    )
}

function RemoveCompanyTitle({label}) {
    return (
        <Box sx={styles.text}>
            {label.REMOVE_COMPANY}
            <InformationTooltip label={"Remove the company and delete all data from Teams and Trends. Billing records are preserved. This operation is irreversible."} />
        </Box>
    )
}

export default function RemoveCompany({organizationId, mode}) {
    const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
    const {removeProcesses, loading} = useGetRemoveProcesses(organizationId);
    const label = getLabel(fragmentId.OFF_BOARD);
    const toggleConfirmationModal = () => setOpenConfirmationModal(!openConfirmationModal);

    const handleRemove = () => {
        toggleConfirmationModal()
    };

    const isRemoveDisabled = loading || removeProcesses.removeInProgress;

    const BodyContent = () => {
        if (loading) {
            return (
                <Box sx={commonStyles.bodyLoading}>
                    <CircularProgress sx={commonStyles.bodyLoadingSpinner}/>
                </Box>
            )
        }
        return (
            <Box sx={{mt: '15px'}}>
                <RemoveCompanyConfirmationModal
                    openConfirmationModal={openConfirmationModal}
                    closeConfirmationModal={toggleConfirmationModal}
                    organizationName={removeProcesses.organizationName}
                    organizationId={organizationId}
                />
                <Box sx={styles.headerSection}>
                    <RemoveCompanyTitle label={label}/>
                    {mode === accessibilityMode.EDIT &&
                        <Box>
                            <Tooltip title="The remove process is in progress"
                                     disableHoverListener={!isRemoveDisabled}>
                            <span>
                                <ActionButton
                                    label={'Remove'}
                                    action={handleRemove}
                                    withIcon={false}
                                    disabled={isRemoveDisabled}
                                    sx={styles.removeButton}
                                />
                            </span>
                            </Tooltip>
                        </Box>
                    }
                </Box>
                <RemoveProcesses removeProcesses={removeProcesses.items}/>
            </Box>
        )
    }

    return <BodyContent/>
}

const styles = {
    headerSection: {
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        justifyContent: 'space-between'
    },
    text: {
        fontSize: '16px',
        fontFamily: 'LarsseitMedium',
        display: 'flex',
        alignItems: 'center',
        gap: '5px',
    },
    infoIcon: {
        fontSize: '18px'
    },
    removeButton: {
        width: '100px',
        height: '30px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },

}